import api from './api';
import { getItem } from './localSorage';

import HistoryInterface from '../interfaces/history';
import ItemsStatusInterface from '../interfaces/itemsStatus';

interface HistoryResponse {
  data: any;
}

const normalize = (response: any): HistoryInterface[] => {

  return response.map((item: any) => {
    return {
      id: item.history.id,
      // foi necessario realizar esse replace para compatibilidade com o ie10
      date: new Date(item.history.created_at.replace(' ', 'T')),
      itemId: item.history.prescription_item_id,
      dispensationId: item.history.dispensation_id,
      quantity: item.history.quantity,
      user: {
        name: item.user.name,
      },
      drugstore: {
        name: item.drugstore.chain.name,
      },
      action: item.history.action,
    };
  });
};

export const fetchHistoryAndItemsStatus = (
  prescriptionToken: string,
): Promise<{
  history: HistoryInterface[];
  itemsStatus: ItemsStatusInterface[];
  showFullPrescriptionDownloadButton: boolean;
}> => {
  const params = [
    `token=${getItem('token')}`,
    `prescription_token=${prescriptionToken}`,
  ].join('&');
  const uri = `dispenser/history?${params}`;

  return api.get(uri).then((response: HistoryResponse) => {
    const { history, items_status } = response.data.data;

    const responseFormatted = {
      history: normalize(history),
      itemsStatus: items_status || [],
      showFullPrescriptionDownloadButton: response.data.data.show_full_prescription_download_button,
    };

    return responseFormatted;
  });
};
